import React from 'react';

const YearSlider = ({ years, selectedYear, onChange }) => {
  const minYear = years[0];
  const maxYear = years[years.length - 1];
  const currentYear = new Date().getFullYear();
  
  const handleChange = (e) => {
    onChange(parseInt(e.target.value));
  };

  return (
    <div className="slider-container">
      <label htmlFor="year-slider">
        Select Year: {selectedYear}
        {selectedYear === currentYear && (
          <span className="current-year-badge">Current</span>
        )}
      </label>
      <input
        type="range"
        id="year-slider"
        min={minYear}
        max={maxYear}
        value={selectedYear}
        onChange={handleChange}
        step="1"
        className="slider"
      />
      <div className="slider-labels">
        {years.filter(year => year % 5 === 0 || year === currentYear).map(year => (
          <span 
            key={year} 
            style={{ 
              left: `${((year - minYear) / (maxYear - minYear)) * 100}%`,
              fontWeight: year === currentYear ? 'bold' : 'normal',
              color: year === currentYear ? '#28a745' : '#666'
            }}
          >
            {year}
            {year === currentYear && ' (Now)'}
          </span>
        ))}
      </div>
    </div>
  );
};

export default YearSlider;